import { LoadingSpinner } from "../../atoms/LoadingSpinner/LoadingSpinner";

export function LoadingScreen() {
  return (
    <div className="min-h-full flex items-center justify-center bg-background">
      <LoadingSpinner />
    </div>
  );
}
